import { render, staticRenderFns } from "./Weekly.vue?vue&type=template&id=42f66b1b&scoped=true&"
import script from "./Weekly.vue?vue&type=script&lang=js&"
export * from "./Weekly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f66b1b",
  null
  
)

export default component.exports